var map = {
	"./404.svg": "sEM+",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./guide.svg": "z74U",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./menu-app.svg": "mU0o",
	"./menu-bank.svg": "T5Hx",
	"./menu-commission.svg": "46bu",
	"./menu-finance.svg": "+N5c",
	"./menu-general.svg": "77Ct",
	"./menu-order.svg": "YwL1",
	"./menu-permission.svg": "FrAW",
	"./menu-profile.svg": "1TlK",
	"./menu-project.svg": "QeWE",
	"./menu-statistics.svg": "hWs7",
	"./menu-user.svg": "3xbk",
	"./menu-withdraw.svg": "VULb",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./qq.svg": "R2jY",
	"./search.svg": "Bx0U",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./th-addressbook.svg": "rJDY",
	"./th-airplane.svg": "iyQQ",
	"./th-airplaneinflight.svg": "T9V5",
	"./th-airplanelanding.svg": "pWzu",
	"./th-airplanetakeoff.svg": "l2+R",
	"./th-airplanetilt.svg": "/liw",
	"./th-airplay.svg": "D7w6",
	"./th-airtrafficcontrol.svg": "HLkV",
	"./th-alarm.svg": "hCIF",
	"./th-alien.svg": "Ws/U",
	"./th-alignbottom.svg": "o7tl",
	"./th-alignbottomsimple.svg": "NGyr",
	"./th-aligncenterhorizontal.svg": "OuXB",
	"./th-aligncenterhorizontalsimple.svg": "mFPi",
	"./th-aligncentervertical.svg": "j6nB",
	"./th-aligncenterverticalsimple.svg": "XHF3",
	"./th-alignleft.svg": "xtCP",
	"./th-alignleftsimple.svg": "GdCk",
	"./th-alignright.svg": "7/TV",
	"./th-alignrightsimple.svg": "fGB/",
	"./th-aligntop.svg": "GWTm",
	"./th-aligntopsimple.svg": "q4pe",
	"./th-amazonlogo.svg": "pGq0",
	"./th-anchor.svg": "YhzS",
	"./th-anchorsimple.svg": "I5Ez",
	"./th-androidlogo.svg": "YP3N",
	"./th-angularlogo.svg": "yZrz",
	"./th-aperture.svg": "ZWqj",
	"./th-applelogo.svg": "CzGE",
	"./th-applepodcastslogo.svg": "DHS6",
	"./th-appstorelogo.svg": "s3X/",
	"./th-appwindow.svg": "IFbv",
	"./th-archive.svg": "dJ5y",
	"./th-archivebox.svg": "yUNu",
	"./th-archivetray.svg": "B4TM",
	"./th-armchair.svg": "Of02",
	"./th-arrowarcleft.svg": "EXPP",
	"./th-arrowarcright.svg": "U6O/",
	"./th-arrowbenddoubleupleft.svg": "1dht",
	"./th-arrowbenddoubleupright.svg": "0KgE",
	"./th-arrowbenddownleft.svg": "7KnH",
	"./th-arrowbenddownright.svg": "Hm+o",
	"./th-arrowbendleftdown.svg": "B2fg",
	"./th-arrowbendleftup.svg": "N2or",
	"./th-arrowbendrightdown.svg": "3Khd",
	"./th-arrowbendrightup.svg": "LFn/",
	"./th-arrowbendupleft.svg": "DirF",
	"./th-arrowbendupright.svg": "PHyN",
	"./th-arrowcircledown.svg": "UpDr",
	"./th-arrowcircledownleft.svg": "AyFs",
	"./th-arrowcircledownright.svg": "HppP",
	"./th-arrowcircleleft.svg": "57wC",
	"./th-arrowcircleright.svg": "MIIZ",
	"./th-arrowcircleup.svg": "Pduf",
	"./th-arrowcircleupleft.svg": "vgaM",
	"./th-arrowcircleupright.svg": "TN69",
	"./th-arrowclockwise.svg": "BAb2",
	"./th-arrowcounterclockwise.svg": "ViNR",
	"./th-arrowdown.svg": "4FOp",
	"./th-arrowdownleft.svg": "yrpw",
	"./th-arrowdownright.svg": "kT++",
	"./th-arrowelbowdownleft.svg": "iAnY",
	"./th-arrowelbowdownright.svg": "Y3P5",
	"./th-arrowelbowleft.svg": "kpNe",
	"./th-arrowelbowleftdown.svg": "HqVx",
	"./th-arrowelbowleftup.svg": "fLq8",
	"./th-arrowelbowright.svg": "oKqT",
	"./th-arrowelbowrightdown.svg": "DRx2",
	"./th-arrowelbowrightup.svg": "qLpM",
	"./th-arrowelbowupleft.svg": "4vh+",
	"./th-arrowelbowupright.svg": "N5Jd",
	"./th-arrowfatdown.svg": "W386",
	"./th-arrowfatleft.svg": "vRQH",
	"./th-arrowfatlinedown.svg": "v/IT",
	"./th-arrowfatlineleft.svg": "g2Vj",
	"./th-arrowfatlineright.svg": "O6Qq",
	"./th-arrowfatlinesdown.svg": "phv1",
	"./th-arrowfatlinesleft.svg": "H/rT",
	"./th-arrowfatlinesright.svg": "X95J",
	"./th-arrowfatlinesup.svg": "cvJ8",
	"./th-arrowfatlineup.svg": "WDor",
	"./th-arrowfatright.svg": "ZGv/",
	"./th-arrowfatup.svg": "MUJ8",
	"./th-arrowleft.svg": "hsQG",
	"./th-arrowlinedown.svg": "DnjR",
	"./th-arrowlinedownleft.svg": "PR5a",
	"./th-arrowlinedownright.svg": "JF1Y",
	"./th-arrowlineleft.svg": "B2uP",
	"./th-arrowlineright.svg": "KOoG",
	"./th-arrowlineup.svg": "OqOE",
	"./th-arrowlineupleft.svg": "7ulE",
	"./th-arrowlineupright.svg": "nDnq",
	"./th-arrowright.svg": "JeiI",
	"./th-arrowsclockwise.svg": "Aj8O",
	"./th-arrowscounterclockwise.svg": "iSYt",
	"./th-arrowsdownup.svg": "3aRt",
	"./th-arrowshorizontal.svg": "K7z3",
	"./th-arrowsin.svg": "/SCF",
	"./th-arrowsincardinal.svg": "RJIv",
	"./th-arrowsinlinehorizontal.svg": "ZXXS",
	"./th-arrowsinlinevertical.svg": "Y/xd",
	"./th-arrowsinsimple.svg": "Rsjo",
	"./th-arrowsleftright.svg": "ebsm",
	"./th-arrowsmerge.svg": "/v79",
	"./th-arrowsout.svg": "kTUA",
	"./th-arrowsoutcardinal.svg": "L48a",
	"./th-arrowsoutlinehorizontal.svg": "Alm/",
	"./th-arrowsoutlinevertical.svg": "+aU/",
	"./th-arrowsoutsimple.svg": "cAsX",
	"./th-arrowsquaredown.svg": "xqs9",
	"./th-arrowsquaredownleft.svg": "aiBx",
	"./th-arrowsquaredownright.svg": "gnNo",
	"./th-arrowsquarein.svg": "zT9P",
	"./th-arrowsquareleft.svg": "lU9R",
	"./th-arrowsquareout.svg": "qjzH",
	"./th-arrowsquareright.svg": "utrK",
	"./th-arrowsquareup.svg": "tEwS",
	"./th-arrowsquareupleft.svg": "TL9t",
	"./th-arrowsquareupright.svg": "t9cH",
	"./th-arrowssplit.svg": "H+AL",
	"./th-arrowsvertical.svg": "yS3N",
	"./th-arrowudownleft.svg": "Wvbh",
	"./th-arrowudownright.svg": "DhcU",
	"./th-arrowuleftdown.svg": "kCfw",
	"./th-arrowuleftup.svg": "+5/A",
	"./th-arrowup.svg": "KWhK",
	"./th-arrowupleft.svg": "aYCB",
	"./th-arrowupright.svg": "wc6G",
	"./th-arrowurightdown.svg": "oXpF",
	"./th-arrowurightup.svg": "G7tT",
	"./th-arrowuupleft.svg": "GYSy",
	"./th-arrowuupright.svg": "L9N3",
	"./th-article.svg": "qX6+",
	"./th-articlemedium.svg": "NgIW",
	"./th-articlenytimes.svg": "E3uA",
	"./th-asterisk.svg": "/Ib5",
	"./th-asterisksimple.svg": "nLyX",
	"./th-at.svg": "+qkG",
	"./th-atom.svg": "a9CS",
	"./th-baby.svg": "lxHx",
	"./th-backpack.svg": "eMDy",
	"./th-backspace.svg": "rMJ+",
	"./th-bag.svg": "u7wW",
	"./th-bagsimple.svg": "jb9K",
	"./th-balloon.svg": "V0IO",
	"./th-bandaids.svg": "HmQX",
	"./th-bank.svg": "MYXk",
	"./th-barbell.svg": "AoQK",
	"./th-barcode.svg": "2yh0",
	"./th-barricade.svg": "cYq1",
	"./th-baseball.svg": "lHCk",
	"./th-baseballcap.svg": "l6N3",
	"./th-basket.svg": "CDzd",
	"./th-basketball.svg": "FEi2",
	"./th-bathtub.svg": "hqCp",
	"./th-batterycharging.svg": "3ce/",
	"./th-batterychargingvertical.svg": "jaQP",
	"./th-batteryempty.svg": "H6Gy",
	"./th-batteryfull.svg": "Kmyo",
	"./th-batteryhigh.svg": "/97Z",
	"./th-batterylow.svg": "mcD/",
	"./th-batterymedium.svg": "Y2rq",
	"./th-batteryplus.svg": "jtmW",
	"./th-batteryplusvertical.svg": "HozJ",
	"./th-batteryverticalempty.svg": "R/to",
	"./th-batteryverticalfull.svg": "BsdG",
	"./th-batteryverticalhigh.svg": "1NnF",
	"./th-batteryverticallow.svg": "RyQz",
	"./th-batteryverticalmedium.svg": "2w3M",
	"./th-batterywarning.svg": "Xm21",
	"./th-batterywarningvertical.svg": "hSPL",
	"./th-bed.svg": "C64C",
	"./th-beerbottle.svg": "jERP",
	"./th-beerstein.svg": "6+Cz",
	"./th-behancelogo.svg": "XpDj",
	"./th-bell.svg": "QdAX",
	"./th-bellringing.svg": "uvB6",
	"./th-bellsimple.svg": "JH2T",
	"./th-bellsimpleringing.svg": "/mUH",
	"./th-bellsimpleslash.svg": "4R39",
	"./th-bellsimplez.svg": "w/li",
	"./th-bellslash.svg": "UXB2",
	"./th-bellz.svg": "9vu7",
	"./th-beziercurve.svg": "rkc1",
	"./th-bicycle.svg": "yXah",
	"./th-binoculars.svg": "tcft",
	"./th-bird.svg": "6DJh",
	"./th-bluetooth.svg": "CJDk",
	"./th-bluetoothconnected.svg": "Gaie",
	"./th-bluetoothslash.svg": "2UK/",
	"./th-bluetoothx.svg": "JKQ4",
	"./th-boat.svg": "ymoH",
	"./th-bone.svg": "h8Bd",
	"./th-book.svg": "Z/NG",
	"./th-bookbookmark.svg": "SBhW",
	"./th-bookmark.svg": "n8tx",
	"./th-bookmarks.svg": "t2ax",
	"./th-bookmarksimple.svg": "Lo2V",
	"./th-bookmarkssimple.svg": "eY+e",
	"./th-bookopen.svg": "U67X",
	"./th-bookopentext.svg": "IltG",
	"./th-books.svg": "30sB",
	"./th-boot.svg": "NlsQ",
	"./th-boundingbox.svg": "tRuE",
	"./th-bowlfood.svg": "2rEN",
	"./th-bracketsangle.svg": "+f+V",
	"./th-bracketscurly.svg": "3707",
	"./th-bracketsround.svg": "W7nx",
	"./th-bracketssquare.svg": "32sN",
	"./th-brain.svg": "gNbD",
	"./th-brandy.svg": "iw/B",
	"./th-bridge.svg": "vSuA",
	"./th-briefcase.svg": "rbux",
	"./th-briefcasemetal.svg": "9u+w",
	"./th-broadcast.svg": "lgiq",
	"./th-broom.svg": "+uxM",
	"./th-browser.svg": "szrI",
	"./th-browsers.svg": "d5D8",
	"./th-bug.svg": "xLF3",
	"./th-bugbeetle.svg": "ED1r",
	"./th-bugdroid.svg": "jhoS",
	"./th-buildings.svg": "6YW1",
	"./th-bus.svg": "ic/N",
	"./th-butterfly.svg": "gaDK",
	"./th-cactus.svg": "gZA2",
	"./th-cake.svg": "eI3t",
	"./th-calculator.svg": "FB1E",
	"./th-calendar.svg": "ikB1",
	"./th-calendarblank.svg": "gI7v",
	"./th-calendarcheck.svg": "rIM0",
	"./th-calendarplus.svg": "H0fd",
	"./th-calendarx.svg": "WAkT",
	"./th-callbell.svg": "v/0O",
	"./th-camera.svg": "mlpj",
	"./th-cameraplus.svg": "V220",
	"./th-camerarotate.svg": "GM1H",
	"./th-cameraslash.svg": "uwlo",
	"./th-campfire.svg": "LUUj",
	"./th-car.svg": "xQYE",
	"./th-cardholder.svg": "0Pv5",
	"./th-cards.svg": "0f8T",
	"./th-caretcircledoubledown.svg": "FrZT",
	"./th-caretcircledoubleleft.svg": "CjVe",
	"./th-caretcircledoubleright.svg": "qPta",
	"./th-caretcircledoubleup.svg": "U72d",
	"./th-caretcircledown.svg": "xr2o",
	"./th-caretcircleleft.svg": "1Tw7",
	"./th-caretcircleright.svg": "n8+3",
	"./th-caretcircleup.svg": "AetO",
	"./th-caretcircleupdown.svg": "k6ra",
	"./th-caretdoubledown.svg": "zdmf",
	"./th-caretdoubleleft.svg": "KfeN",
	"./th-caretdoubleright.svg": "fY2E",
	"./th-caretdoubleup.svg": "PeI1",
	"./th-caretdown.svg": "i4tn",
	"./th-caretleft.svg": "yv6h",
	"./th-caretright.svg": "l0xp",
	"./th-caretup.svg": "w+bW",
	"./th-caretupdown.svg": "49OV",
	"./th-carprofile.svg": "j8mR",
	"./th-carrot.svg": "TC5E",
	"./th-carsimple.svg": "oNs8",
	"./th-cassettetape.svg": "ozKS",
	"./th-castleturret.svg": "fU1Y",
	"./th-cat.svg": "aQye",
	"./th-cellsignalfull.svg": "ZNwY",
	"./th-cellsignalhigh.svg": "r3vA",
	"./th-cellsignallow.svg": "Hsd9",
	"./th-cellsignalmedium.svg": "64iO",
	"./th-cellsignalnone.svg": "DDWk",
	"./th-cellsignalslash.svg": "Gj+E",
	"./th-cellsignalx.svg": "XHT6",
	"./th-certificate.svg": "FuXG",
	"./th-chair.svg": "EnPL",
	"./th-chalkboard.svg": "uPbQ",
	"./th-chalkboardsimple.svg": "0sQD",
	"./th-chalkboardteacher.svg": "6MON",
	"./th-champagne.svg": "gdJ4",
	"./th-chargingstation.svg": "Yy3X",
	"./th-chartbar.svg": "qe4f",
	"./th-chartbarhorizontal.svg": "EVQ3",
	"./th-chartdonut.svg": "tiFL",
	"./th-chartline.svg": "GcNP",
	"./th-chartlinedown.svg": "jeF4",
	"./th-chartlineup.svg": "jhAr",
	"./th-chartpie.svg": "Nr6j",
	"./th-chartpieslice.svg": "9rR/",
	"./th-chartpolar.svg": "23ud",
	"./th-chartscatter.svg": "YQ2P",
	"./th-chat.svg": "2paD",
	"./th-chatcentered.svg": "7nks",
	"./th-chatcentereddots.svg": "BjWy",
	"./th-chatcenteredtext.svg": "jBR5",
	"./th-chatcircle.svg": "LKH4",
	"./th-chatcircledots.svg": "Z+86",
	"./th-chatcircletext.svg": "q2A4",
	"./th-chatdots.svg": "sAHe",
	"./th-chats.svg": "LncT",
	"./th-chatscircle.svg": "r4OK",
	"./th-chatsteardrop.svg": "/fVq",
	"./th-chatteardrop.svg": "E156",
	"./th-chatteardropdots.svg": "j8Zr",
	"./th-chatteardroptext.svg": "OpC3",
	"./th-chattext.svg": "vj05",
	"./th-check.svg": "JHsp",
	"./th-checkcircle.svg": "M/rH",
	"./th-checkfat.svg": "9xm0",
	"./th-checks.svg": "euMu",
	"./th-checksquare.svg": "umTT",
	"./th-checksquareoffset.svg": "DCSe",
	"./th-church.svg": "8nmb",
	"./th-circle.svg": "PaSI",
	"./th-circledashed.svg": "EAfs",
	"./th-circlehalf.svg": "nNwP",
	"./th-circlehalftilt.svg": "LST1",
	"./th-circlenotch.svg": "fJZn",
	"./th-circlesfour.svg": "nocr",
	"./th-circlesthree.svg": "lCCN",
	"./th-circlesthreeplus.svg": "99Kf",
	"./th-circuitry.svg": "9w4c",
	"./th-clipboard.svg": "ZkM3",
	"./th-clipboardtext.svg": "5uot",
	"./th-clock.svg": "VvrI",
	"./th-clockafternoon.svg": "eSvU",
	"./th-clockclockwise.svg": "aOVG",
	"./th-clockcountdown.svg": "/dgX",
	"./th-clockcounterclockwise.svg": "xvcc",
	"./th-closedcaptioning.svg": "5CoU",
	"./th-cloud.svg": "UJEk",
	"./th-cloudarrowdown.svg": "sI2y",
	"./th-cloudarrowup.svg": "uO9U",
	"./th-cloudcheck.svg": "YkSG",
	"./th-cloudfog.svg": "vKG6",
	"./th-cloudlightning.svg": "dbj8",
	"./th-cloudmoon.svg": "nyzd",
	"./th-cloudrain.svg": "byOn",
	"./th-cloudslash.svg": "87qj",
	"./th-cloudsnow.svg": "4vyr",
	"./th-cloudsun.svg": "EOYq",
	"./th-cloudwarning.svg": "cmrf",
	"./th-cloudx.svg": "z4oH",
	"./th-club.svg": "cS+1",
	"./th-coathanger.svg": "U7Pz",
	"./th-codalogo.svg": "1z/V",
	"./th-code.svg": "zXUg",
	"./th-codeblock.svg": "qs9J",
	"./th-codepenlogo.svg": "Wlm7",
	"./th-codesandboxlogo.svg": "5/No",
	"./th-codesimple.svg": "L8IA",
	"./th-coffee.svg": "u+fU",
	"./th-coin.svg": "7g22",
	"./th-coins.svg": "f294",
	"./th-coinvertical.svg": "nulh",
	"./th-columns.svg": "Y1BZ",
	"./th-command.svg": "p8gc",
	"./th-compass.svg": "/UeH",
	"./th-compasstool.svg": "zshV",
	"./th-computertower.svg": "2JIU",
	"./th-confetti.svg": "gz4K",
	"./th-contactlesspayment.svg": "7S4O",
	"./th-control.svg": "4wK9",
	"./th-cookie.svg": "iSDV",
	"./th-cookingpot.svg": "Wvel",
	"./th-copy.svg": "XFAZ",
	"./th-copyleft.svg": "xVgx",
	"./th-copyright.svg": "Ih3O",
	"./th-copysimple.svg": "p73F",
	"./th-cornersin.svg": "zqov",
	"./th-cornersout.svg": "f8yp",
	"./th-couch.svg": "/V6b",
	"./th-cpu.svg": "IYuL",
	"./th-creditcard.svg": "HJTi",
	"./th-crop.svg": "kgLR",
	"./th-cross.svg": "+BNs",
	"./th-crosshair.svg": "+kuP",
	"./th-crosshairsimple.svg": "IWll",
	"./th-crown.svg": "tne0",
	"./th-crownsimple.svg": "uHZH",
	"./th-cube.svg": "D/m7",
	"./th-cubefocus.svg": "ksDY",
	"./th-cubetransparent.svg": "IMpV",
	"./th-currencybtc.svg": "xjGv",
	"./th-currencycircledollar.svg": "4grr",
	"./th-currencycny.svg": "8Plu",
	"./th-currencydollar.svg": "sdsL",
	"./th-currencydollarsimple.svg": "6S81",
	"./th-currencyeth.svg": "apZl",
	"./th-currencyeur.svg": "7nki",
	"./th-currencygbp.svg": "PDqo",
	"./th-currencyinr.svg": "EaDi",
	"./th-currencyjpy.svg": "z4yq",
	"./th-currencykrw.svg": "Gum2",
	"./th-currencykzt.svg": "TYsu",
	"./th-currencyngn.svg": "AMw3",
	"./th-currencyrub.svg": "suKQ",
	"./th-cursor.svg": "bzzl",
	"./th-cursorclick.svg": "0R7+",
	"./th-cursortext.svg": "m1MO",
	"./th-cylinder.svg": "6DQV",
	"./th-database.svg": "6Zev",
	"./th-desktop.svg": "FvSf",
	"./th-desktoptower.svg": "/QoB",
	"./th-detective.svg": "jIpg",
	"./th-devicemobile.svg": "rxzI",
	"./th-devicemobilecamera.svg": "hhjX",
	"./th-devicemobilespeaker.svg": "0SwK",
	"./th-devices.svg": "fHW1",
	"./th-devicetablet.svg": "1ReN",
	"./th-devicetabletcamera.svg": "aTVd",
	"./th-devicetabletspeaker.svg": "JE1c",
	"./th-devtologo.svg": "yjtg",
	"./th-diamond.svg": "fbax",
	"./th-diamondsfour.svg": "BCLD",
	"./th-dicefive.svg": "aauz",
	"./th-dicefour.svg": "foIJ",
	"./th-diceone.svg": "GjOG",
	"./th-dicesix.svg": "zRI2",
	"./th-dicethree.svg": "IiA0",
	"./th-dicetwo.svg": "x8mV",
	"./th-disc.svg": "jWvX",
	"./th-discordlogo.svg": "tNdV",
	"./th-divide.svg": "H6zi",
	"./th-dna.svg": "6Z1E",
	"./th-dog.svg": "Wl5t",
	"./th-door.svg": "Rdls",
	"./th-dooropen.svg": "+IS6",
	"./th-dot.svg": "s9lf",
	"./th-dotoutline.svg": "cfk4",
	"./th-dotsnine.svg": "9S8X",
	"./th-dotssix.svg": "xmqc",
	"./th-dotssixvertical.svg": "iOPB",
	"./th-dotsthree.svg": "giHD",
	"./th-dotsthreecircle.svg": "s+tD",
	"./th-dotsthreecirclevertical.svg": "3S3P",
	"./th-dotsthreeoutline.svg": "K5HH",
	"./th-dotsthreeoutlinevertical.svg": "Ax5d",
	"./th-dotsthreevertical.svg": "YVNR",
	"./th-download.svg": "isvG",
	"./th-downloadsimple.svg": "acaZ",
	"./th-dress.svg": "+jgq",
	"./th-dribbblelogo.svg": "w8wp",
	"./th-drop.svg": "GpXh",
	"./th-dropboxlogo.svg": "emEz",
	"./th-drophalf.svg": "laiC",
	"./th-drophalfbottom.svg": "VZjw",
	"./th-ear.svg": "qaQO",
	"./th-earslash.svg": "USct",
	"./th-egg.svg": "WieB",
	"./th-eggcrack.svg": "iaIY",
	"./th-eject.svg": "hpBF",
	"./th-ejectsimple.svg": "++9d",
	"./th-elevator.svg": "lwjs",
	"./th-engine.svg": "7C65",
	"./th-envelope.svg": "PgFA",
	"./th-envelopeopen.svg": "UENv",
	"./th-envelopesimple.svg": "Rm3D",
	"./th-envelopesimpleopen.svg": "90Zs",
	"./th-equalizer.svg": "aG6E",
	"./th-equals.svg": "0rCR",
	"./th-eraser.svg": "K4c7",
	"./th-escalatordown.svg": "GsNv",
	"./th-escalatorup.svg": "eoc0",
	"./th-exam.svg": "lbWd",
	"./th-exclude.svg": "DdjJ",
	"./th-excludesquare.svg": "/6LB",
	"./th-export.svg": "83A9",
	"./th-eye.svg": "30FL",
	"./th-eyeclosed.svg": "28a2",
	"./th-eyedropper.svg": "S9bD",
	"./th-eyedroppersample.svg": "qfjC",
	"./th-eyeglasses.svg": "tfAd",
	"./th-eyeslash.svg": "9cBT",
	"./th-facebooklogo.svg": "LUwn",
	"./th-facemask.svg": "+fqG",
	"./th-factory.svg": "jrgr",
	"./th-faders.svg": "eAdA",
	"./th-fadershorizontal.svg": "qO2h",
	"./th-fan.svg": "wn1e",
	"./th-fastforward.svg": "zyFW",
	"./th-fastforwardcircle.svg": "tk1D",
	"./th-feather.svg": "qwLP",
	"./th-figmalogo.svg": "q3/X",
	"./th-file.svg": "epbS",
	"./th-filearchive.svg": "LUbw",
	"./th-filearrowdown.svg": "BsPh",
	"./th-filearrowup.svg": "GY18",
	"./th-fileaudio.svg": "SRbA",
	"./th-filecloud.svg": "sVYP",
	"./th-filecode.svg": "QQ3v",
	"./th-filecss.svg": "KUVg",
	"./th-filecsv.svg": "w1nx",
	"./th-filedashed.svg": "Usin",
	"./th-filedoc.svg": "GMvY",
	"./th-filehtml.svg": "zn7V",
	"./th-fileimage.svg": "Uhef",
	"./th-filejpg.svg": "M8XJ",
	"./th-filejs.svg": "7CE2",
	"./th-filejsx.svg": "IIQ+",
	"./th-filelock.svg": "3a3q",
	"./th-fileminus.svg": "/AK4",
	"./th-filepdf.svg": "D51F",
	"./th-fileplus.svg": "b4C1",
	"./th-filepng.svg": "DSjN",
	"./th-fileppt.svg": "JNu2",
	"./th-filers.svg": "jD1W",
	"./th-files.svg": "Ckb/",
	"./th-filesearch.svg": "mPkL",
	"./th-filesql.svg": "/Io8",
	"./th-filesvg.svg": "QUMc",
	"./th-filetext.svg": "CwBW",
	"./th-filets.svg": "hmdu",
	"./th-filetsx.svg": "ol2S",
	"./th-filevideo.svg": "UrCv",
	"./th-filevue.svg": "MrGu",
	"./th-filex.svg": "lCfp",
	"./th-filexls.svg": "XP6E",
	"./th-filezip.svg": "5pYs",
	"./th-filmreel.svg": "5p10",
	"./th-filmscript.svg": "pa3K",
	"./th-filmslate.svg": "qtx2",
	"./th-filmstrip.svg": "ihlp",
	"./th-fingerprint.svg": "CwM0",
	"./th-fingerprintsimple.svg": "T1In",
	"./th-finnthehuman.svg": "GPNI",
	"./th-fire.svg": "gUoW",
	"./th-fireextinguisher.svg": "Hs5Y",
	"./th-firesimple.svg": "X+wY",
	"./th-firstaid.svg": "smJd",
	"./th-firstaidkit.svg": "LJbi",
	"./th-fish.svg": "hu+W",
	"./th-fishsimple.svg": "qCuA",
	"./th-flag.svg": "hE6r",
	"./th-flagbanner.svg": "5k9/",
	"./th-flagcheckered.svg": "pUvi",
	"./th-flagpennant.svg": "Rykq",
	"./th-flame.svg": "oncU",
	"./th-flashlight.svg": "9kXs",
	"./th-flask.svg": "1NE1",
	"./th-floppydisk.svg": "60G0",
	"./th-floppydiskback.svg": "Uu6u",
	"./th-flowarrow.svg": "023D",
	"./th-flower.svg": "2k0M",
	"./th-flowerlotus.svg": "CGq1",
	"./th-flowertulip.svg": "RceB",
	"./th-flyingsaucer.svg": "P833",
	"./th-folder.svg": "zW04",
	"./th-folderdashed.svg": "C60P",
	"./th-folderlock.svg": "mpjo",
	"./th-folderminus.svg": "olqI",
	"./th-foldernotch.svg": "dW2m",
	"./th-foldernotchminus.svg": "pqgA",
	"./th-foldernotchopen.svg": "DNlo",
	"./th-foldernotchplus.svg": "amZD",
	"./th-folderopen.svg": "bQZi",
	"./th-folderplus.svg": "II4a",
	"./th-folders.svg": "PXqh",
	"./th-foldersimple.svg": "VotU",
	"./th-foldersimpledashed.svg": "pmcE",
	"./th-foldersimplelock.svg": "u7cv",
	"./th-foldersimpleminus.svg": "jR71",
	"./th-foldersimpleplus.svg": "ATNQ",
	"./th-foldersimplestar.svg": "QAbh",
	"./th-foldersimpleuser.svg": "yQ0M",
	"./th-folderstar.svg": "TCc5",
	"./th-folderuser.svg": "e1V2",
	"./th-football.svg": "snnD",
	"./th-footprints.svg": "Oc4k",
	"./th-forkknife.svg": "+DaA",
	"./th-framecorners.svg": "LRUV",
	"./th-framerlogo.svg": "R6aY",
	"./th-function.svg": "Bwe5",
	"./th-funnel.svg": "kyPK",
	"./th-funnelsimple.svg": "cCEE",
	"./th-gamecontroller.svg": "y7z9",
	"./th-garage.svg": "OXBX",
	"./th-gascan.svg": "xfKQ",
	"./th-gaspump.svg": "TiMn",
	"./th-gauge.svg": "IARJ",
	"./th-gavel.svg": "oIcv",
	"./th-gear.svg": "fHCK",
	"./th-gearfine.svg": "XHW3",
	"./th-gearsix.svg": "4S4W",
	"./th-genderfemale.svg": "5sx7",
	"./th-genderintersex.svg": "xShy",
	"./th-gendermale.svg": "hHgO",
	"./th-genderneuter.svg": "6E/T",
	"./th-gendernonbinary.svg": "w+O6",
	"./th-gendertransgender.svg": "B5B/",
	"./th-ghost.svg": "QURN",
	"./th-gif.svg": "MQAe",
	"./th-gift.svg": "S5Jb",
	"./th-gitbranch.svg": "NWxY",
	"./th-gitcommit.svg": "pezh",
	"./th-gitdiff.svg": "1MzU",
	"./th-gitfork.svg": "2/LD",
	"./th-githublogo.svg": "FQIY",
	"./th-gitlablogo.svg": "TBZq",
	"./th-gitlablogosimple.svg": "QmOx",
	"./th-gitmerge.svg": "Qyd/",
	"./th-gitpullrequest.svg": "TAiU",
	"./th-globe.svg": "DeqG",
	"./th-globehemisphereeast.svg": "joNa",
	"./th-globehemispherewest.svg": "NWML",
	"./th-globesimple.svg": "NhEX",
	"./th-globestand.svg": "ekxi",
	"./th-goggles.svg": "ZqHE",
	"./th-goodreadslogo.svg": "IYge",
	"./th-googlecardboardlogo.svg": "40Wf",
	"./th-googlechromelogo.svg": "YiJ6",
	"./th-googledrivelogo.svg": "/PHZ",
	"./th-googlelogo.svg": "qbA5",
	"./th-googlephotoslogo.svg": "SqBg",
	"./th-googleplaylogo.svg": "zqen",
	"./th-googlepodcastslogo.svg": "Pr1N",
	"./th-gradient.svg": "1qKa",
	"./th-graduationcap.svg": "Cz3A",
	"./th-grains.svg": "aHyE",
	"./th-grainsslash.svg": "qS4y",
	"./th-graph.svg": "vvA/",
	"./th-gridfour.svg": "JG6O",
	"./th-gridnine.svg": "ArMF",
	"./th-guitar.svg": "KGq1",
	"./th-hamburger.svg": "m2fj",
	"./th-hammer.svg": "y5dN",
	"./th-hand.svg": "DlOq",
	"./th-handbag.svg": "Xh+n",
	"./th-handbagsimple.svg": "DO0E",
	"./th-handcoins.svg": "RmjQ",
	"./th-handeye.svg": "qK6C",
	"./th-handfist.svg": "0fYZ",
	"./th-handgrabbing.svg": "lB2E",
	"./th-handheart.svg": "vVvm",
	"./th-handpalm.svg": "Fwch",
	"./th-handpointing.svg": "urFn",
	"./th-handsclapping.svg": "N6jC",
	"./th-handshake.svg": "DX6V",
	"./th-handsoap.svg": "pqpK",
	"./th-handspraying.svg": "MUuq",
	"./th-handswipeleft.svg": "ZPy4",
	"./th-handswiperight.svg": "BpZd",
	"./th-handtap.svg": "5L4n",
	"./th-handwaving.svg": "6JE9",
	"./th-harddrive.svg": "L5vf",
	"./th-harddrives.svg": "Op+l",
	"./th-hash.svg": "Ep5Q",
	"./th-hashstraight.svg": "ZSko",
	"./th-headlights.svg": "1mL3",
	"./th-headphones.svg": "MNHl",
	"./th-headset.svg": "QJXZ",
	"./th-heart.svg": "maNR",
	"./th-heartbeat.svg": "GhzG",
	"./th-heartbreak.svg": "cM/k",
	"./th-hearthalf.svg": "hbS2",
	"./th-heartstraight.svg": "gyK8",
	"./th-heartstraightbreak.svg": "KW/D",
	"./th-hexagon.svg": "li1Y",
	"./th-highheel.svg": "f8W+",
	"./th-highlightercircle.svg": "HE4F",
	"./th-hoodie.svg": "m0Ps",
	"./th-horse.svg": "U5k4",
	"./th-hourglass.svg": "PNnZ",
	"./th-hourglasshigh.svg": "DJrR",
	"./th-hourglasslow.svg": "32j5",
	"./th-hourglassmedium.svg": "ncnG",
	"./th-hourglasssimple.svg": "sTrN",
	"./th-hourglasssimplehigh.svg": "ron6",
	"./th-hourglasssimplelow.svg": "hKXp",
	"./th-hourglasssimplemedium.svg": "8vg/",
	"./th-house.svg": "xtZJ",
	"./th-houseline.svg": "vdGc",
	"./th-housesimple.svg": "eJ2W",
	"./th-icecream.svg": "2Tvl",
	"./th-identificationbadge.svg": "K7Ge",
	"./th-identificationcard.svg": "XTZv",
	"./th-image.svg": "GbH4",
	"./th-images.svg": "TH+c",
	"./th-imagesquare.svg": "FXeY",
	"./th-imagessquare.svg": "kvIi",
	"./th-infinity.svg": "YqJX",
	"./th-info.svg": "ofhR",
	"./th-instagramlogo.svg": "Ipzf",
	"./th-intersect.svg": "2GKO",
	"./th-intersectsquare.svg": "RYK5",
	"./th-intersectthree.svg": "z6VZ",
	"./th-jeep.svg": "QyA5",
	"./th-kanban.svg": "1RFh",
	"./th-key.svg": "fgWs",
	"./th-keyboard.svg": "lFrH",
	"./th-keyhole.svg": "/v1Y",
	"./th-keyreturn.svg": "+j9t",
	"./th-knife.svg": "NmJI",
	"./th-ladder.svg": "zVhO",
	"./th-laddersimple.svg": "F6gB",
	"./th-lamp.svg": "S6b3",
	"./th-laptop.svg": "WVYr",
	"./th-layout.svg": "rncW",
	"./th-leaf.svg": "UDt0",
	"./th-lifebuoy.svg": "p9z4",
	"./th-lightbulb.svg": "7XK1",
	"./th-lightbulbfilament.svg": "kWsA",
	"./th-lighthouse.svg": "eiOr",
	"./th-lightning.svg": "Mtrs",
	"./th-lightninga.svg": "Yhq9",
	"./th-lightningslash.svg": "QXYf",
	"./th-linesegment.svg": "uawG",
	"./th-linesegments.svg": "2Zg+",
	"./th-link.svg": "hgSO",
	"./th-linkbreak.svg": "Xeg9",
	"./th-linkedinlogo.svg": "/RQG",
	"./th-linksimple.svg": "MN2j",
	"./th-linksimplebreak.svg": "6Ius",
	"./th-linksimplehorizontal.svg": "udNW",
	"./th-linksimplehorizontalbreak.svg": "Y9wU",
	"./th-linuxlogo.svg": "U163",
	"./th-list.svg": "NEBy",
	"./th-listbullets.svg": "v2+5",
	"./th-listchecks.svg": "+drY",
	"./th-listdashes.svg": "cKUo",
	"./th-listmagnifyingglass.svg": "tocZ",
	"./th-listnumbers.svg": "i1U+",
	"./th-listplus.svg": "wRbX",
	"./th-lock.svg": "j5ex",
	"./th-lockers.svg": "NZZb",
	"./th-lockkey.svg": "SarQ",
	"./th-lockkeyopen.svg": "iV2+",
	"./th-locklaminated.svg": "NXj5",
	"./th-locklaminatedopen.svg": "Gf0G",
	"./th-lockopen.svg": "iuhk",
	"./th-locksimple.svg": "gt6Q",
	"./th-locksimpleopen.svg": "RvBs",
	"./th-magicwand.svg": "a+/Y",
	"./th-magnet.svg": "dAI+",
	"./th-magnetstraight.svg": "CV7D",
	"./th-magnifyingglass.svg": "8Cyl",
	"./th-magnifyingglassminus.svg": "t3Cs",
	"./th-magnifyingglassplus.svg": "Dn2Z",
	"./th-mappin.svg": "qjGu",
	"./th-mappinline.svg": "zpBm",
	"./th-maptrifold.svg": "fYbN",
	"./th-markercircle.svg": "ruy5",
	"./th-martini.svg": "ISJg",
	"./th-maskhappy.svg": "51L5",
	"./th-masksad.svg": "m17+",
	"./th-mathoperations.svg": "Iahf",
	"./th-medal.svg": "FtfT",
	"./th-medalmilitary.svg": "zgNc",
	"./th-mediumlogo.svg": "5Yly",
	"./th-megaphone.svg": "or8Z",
	"./th-megaphonesimple.svg": "dWNZ",
	"./th-messengerlogo.svg": "1d/u",
	"./th-metalogo.svg": "AIHQ",
	"./th-metronome.svg": "96DO",
	"./th-microphone.svg": "i1wp",
	"./th-microphoneslash.svg": "Lp29",
	"./th-microphonestage.svg": "T2Ib",
	"./th-microsoftexcellogo.svg": "P2W3",
	"./th-microsoftoutlooklogo.svg": "fLfM",
	"./th-microsoftpowerpointlogo.svg": "bE6a",
	"./th-microsoftteamslogo.svg": "3BzV",
	"./th-microsoftwordlogo.svg": "eNgp",
	"./th-minus.svg": "pq5k",
	"./th-minuscircle.svg": "bXNV",
	"./th-minussquare.svg": "2g11",
	"./th-money.svg": "eTS4",
	"./th-monitor.svg": "fQdv",
	"./th-monitorplay.svg": "r5FA",
	"./th-moon.svg": "zJus",
	"./th-moonstars.svg": "mEIZ",
	"./th-moped.svg": "t2+h",
	"./th-mopedfront.svg": "VhtO",
	"./th-mosque.svg": "RDB2",
	"./th-motorcycle.svg": "i4rM",
	"./th-mountains.svg": "FwxF",
	"./th-mouse.svg": "YdWh",
	"./th-mousesimple.svg": "hxOO",
	"./th-musicnote.svg": "gLQE",
	"./th-musicnotes.svg": "bMjr",
	"./th-musicnotesimple.svg": "mcMl",
	"./th-musicnotesplus.svg": "/ZIy",
	"./th-musicnotessimple.svg": "2Fyc",
	"./th-navigationarrow.svg": "Trhh",
	"./th-needle.svg": "Orf2",
	"./th-newspaper.svg": "WueC",
	"./th-newspaperclipping.svg": "G1s5",
	"./th-notches.svg": "34re",
	"./th-note.svg": "cgJO",
	"./th-noteblank.svg": "u4Be",
	"./th-notebook.svg": "W9Zm",
	"./th-notepad.svg": "DVFG",
	"./th-notepencil.svg": "0GCD",
	"./th-notification.svg": "hO9Y",
	"./th-notionlogo.svg": "/yD5",
	"./th-numbercircleeight.svg": "p/aZ",
	"./th-numbercirclefive.svg": "2go7",
	"./th-numbercirclefour.svg": "72M0",
	"./th-numbercirclenine.svg": "cgu1",
	"./th-numbercircleone.svg": "cQ9u",
	"./th-numbercircleseven.svg": "HuHq",
	"./th-numbercirclesix.svg": "OTTP",
	"./th-numbercirclethree.svg": "TLAq",
	"./th-numbercircletwo.svg": "J0mz",
	"./th-numbercirclezero.svg": "1ZZe",
	"./th-numbereight.svg": "6GVe",
	"./th-numberfive.svg": "2CDS",
	"./th-numberfour.svg": "qhLA",
	"./th-numbernine.svg": "z4fF",
	"./th-numberone.svg": "24dd",
	"./th-numberseven.svg": "qqXw",
	"./th-numbersix.svg": "WawV",
	"./th-numbersquareeight.svg": "bxjp",
	"./th-numbersquarefive.svg": "FYa5",
	"./th-numbersquarefour.svg": "2aYZ",
	"./th-numbersquarenine.svg": "Qn3I",
	"./th-numbersquareone.svg": "dbCw",
	"./th-numbersquareseven.svg": "fn6J",
	"./th-numbersquaresix.svg": "CkEs",
	"./th-numbersquarethree.svg": "tI4I",
	"./th-numbersquaretwo.svg": "BMXK",
	"./th-numbersquarezero.svg": "Izdq",
	"./th-numberthree.svg": "ac5z",
	"./th-numbertwo.svg": "FxU0",
	"./th-numberzero.svg": "F2bp",
	"./th-nut.svg": "WJHi",
	"./th-nytimeslogo.svg": "eHW3",
	"./th-octagon.svg": "jE8n",
	"./th-officechair.svg": "I1SM",
	"./th-option.svg": "ltkl",
	"./th-orangeslice.svg": "5WMV",
	"./th-package.svg": "tuwg",
	"./th-paintbrush.svg": "K+Cq",
	"./th-paintbrushbroad.svg": "C1h4",
	"./th-paintbrushhousehold.svg": "7Y6I",
	"./th-paintbucket.svg": "Li3x",
	"./th-paintroller.svg": "dngf",
	"./th-palette.svg": "19jR",
	"./th-pants.svg": "lxN3",
	"./th-paperclip.svg": "fLfD",
	"./th-papercliphorizontal.svg": "pgUx",
	"./th-paperplane.svg": "Cy+1",
	"./th-paperplaneright.svg": "yf6G",
	"./th-paperplanetilt.svg": "OLiy",
	"./th-parachute.svg": "gD9N",
	"./th-paragraph.svg": "BhLt",
	"./th-parallelogram.svg": "z7ac",
	"./th-park.svg": "lJNW",
	"./th-password.svg": "bcmA",
	"./th-path.svg": "ZQX3",
	"./th-patreonlogo.svg": "c8wY",
	"./th-pause.svg": "YB4R",
	"./th-pausecircle.svg": "YYKT",
	"./th-pawprint.svg": "3ZOv",
	"./th-paypallogo.svg": "OteD",
	"./th-peace.svg": "y731",
	"./th-pen.svg": "ZHwe",
	"./th-pencil.svg": "RJUU",
	"./th-pencilcircle.svg": "kh/s",
	"./th-pencilline.svg": "OyMz",
	"./th-pencilsimple.svg": "MDNc",
	"./th-pencilsimpleline.svg": "GG98",
	"./th-pencilsimpleslash.svg": "07Cm",
	"./th-pencilslash.svg": "GhbL",
	"./th-pennib.svg": "bbgn",
	"./th-pennibstraight.svg": "tZ9g",
	"./th-pentagram.svg": "aZ4L",
	"./th-pepper.svg": "B8hy",
	"./th-percent.svg": "+9fH",
	"./th-person.svg": "31Lw",
	"./th-personarmsspread.svg": "dLiV",
	"./th-personsimple.svg": "BQSd",
	"./th-personsimplebike.svg": "kJAf",
	"./th-personsimplerun.svg": "v4R0",
	"./th-personsimplethrow.svg": "CHqT",
	"./th-personsimplewalk.svg": "e7xZ",
	"./th-perspective.svg": "Hptg",
	"./th-phone.svg": "tvbw",
	"./th-phonecall.svg": "Cpus",
	"./th-phonedisconnect.svg": "KURE",
	"./th-phoneincoming.svg": "1Pvc",
	"./th-phoneoutgoing.svg": "FHZ2",
	"./th-phoneplus.svg": "jprw",
	"./th-phoneslash.svg": "f9BP",
	"./th-phonex.svg": "4CjH",
	"./th-phosphorlogo.svg": "tNKl",
	"./th-pi.svg": "zQH+",
	"./th-pianokeys.svg": "86TA",
	"./th-pictureinpicture.svg": "1yjq",
	"./th-piggybank.svg": "MbF3",
	"./th-pill.svg": "409h",
	"./th-pinterestlogo.svg": "yiqR",
	"./th-pinwheel.svg": "sPpx",
	"./th-pizza.svg": "EZkb",
	"./th-placeholder.svg": "8TKK",
	"./th-planet.svg": "yyrj",
	"./th-plant.svg": "dr4y",
	"./th-play.svg": "6+07",
	"./th-playcircle.svg": "Gyp0",
	"./th-playlist.svg": "4S8Q",
	"./th-playpause.svg": "NsKN",
	"./th-plug.svg": "OnFL",
	"./th-plugcharging.svg": "Wq6R",
	"./th-plugs.svg": "lm8z",
	"./th-plugsconnected.svg": "2Bsy",
	"./th-plus.svg": "h9ne",
	"./th-pluscircle.svg": "YLGo",
	"./th-plusminus.svg": "LeJf",
	"./th-plussquare.svg": "FCLr",
	"./th-pokerchip.svg": "DPL0",
	"./th-policecar.svg": "r3my",
	"./th-polygon.svg": "e1/6",
	"./th-popcorn.svg": "hfXi",
	"./th-pottedplant.svg": "olQs",
	"./th-power.svg": "Z1Z+",
	"./th-prescription.svg": "sCaN",
	"./th-presentation.svg": "Pu5k",
	"./th-presentationchart.svg": "Jg46",
	"./th-printer.svg": "TZrq",
	"./th-prohibit.svg": "AhMB",
	"./th-prohibitinset.svg": "dD7T",
	"./th-projectorscreen.svg": "Lytr",
	"./th-projectorscreenchart.svg": "V6Az",
	"./th-pulse.svg": "BSCK",
	"./th-pushpin.svg": "50ac",
	"./th-pushpinsimple.svg": "iuAQ",
	"./th-pushpinsimpleslash.svg": "Igq5",
	"./th-pushpinslash.svg": "dLVK",
	"./th-puzzlepiece.svg": "LQzi",
	"./th-qrcode.svg": "2nAR",
	"./th-question.svg": "yo4s",
	"./th-queue.svg": "PHa+",
	"./th-quotes.svg": "ZEaj",
	"./th-radical.svg": "KikD",
	"./th-radio.svg": "2FVH",
	"./th-radioactive.svg": "EuGt",
	"./th-radiobutton.svg": "kWT3",
	"./th-rainbow.svg": "OkZ6",
	"./th-rainbowcloud.svg": "szf+",
	"./th-readcvlogo.svg": "Crt8",
	"./th-receipt.svg": "hXj+",
	"./th-receiptx.svg": "xzr9",
	"./th-record.svg": "XIH1",
	"./th-rectangle.svg": "R3b6",
	"./th-recycle.svg": "OME6",
	"./th-redditlogo.svg": "0qKJ",
	"./th-repeat.svg": "MLaK",
	"./th-repeatonce.svg": "BoB1",
	"./th-rewind.svg": "HdRS",
	"./th-rewindcircle.svg": "XPpL",
	"./th-roadhorizon.svg": "l6Fc",
	"./th-robot.svg": "5Z28",
	"./th-rocket.svg": "7yya",
	"./th-rocketlaunch.svg": "cOhX",
	"./th-rows.svg": "GP4B",
	"./th-rss.svg": "YHM/",
	"./th-rsssimple.svg": "lFCB",
	"./th-rug.svg": "k5VC",
	"./th-ruler.svg": "NRmj",
	"./th-scales.svg": "FeBi",
	"./th-scan.svg": "+CUx",
	"./th-scissors.svg": "n9H5",
	"./th-scooter.svg": "4ifb",
	"./th-screencast.svg": "GFza",
	"./th-scribbleloop.svg": "Bg9r",
	"./th-scroll.svg": "1hiI",
	"./th-seal.svg": "ucim",
	"./th-sealcheck.svg": "DY68",
	"./th-sealquestion.svg": "TUle",
	"./th-sealwarning.svg": "VdTR",
	"./th-selection.svg": "tTgK",
	"./th-selectionall.svg": "c+7b",
	"./th-selectionbackground.svg": "uHZ8",
	"./th-selectionforeground.svg": "4wxp",
	"./th-selectioninverse.svg": "UWvm",
	"./th-selectionplus.svg": "qeKW",
	"./th-selectionslash.svg": "fnle",
	"./th-shapes.svg": "JLbr",
	"./th-share.svg": "4T9s",
	"./th-sharefat.svg": "X+ne",
	"./th-sharenetwork.svg": "CE3A",
	"./th-shield.svg": "ocVl",
	"./th-shieldcheck.svg": "NG8V",
	"./th-shieldcheckered.svg": "bJg9",
	"./th-shieldchevron.svg": "YyVv",
	"./th-shieldplus.svg": "Rax2",
	"./th-shieldslash.svg": "BJwu",
	"./th-shieldstar.svg": "aKhn",
	"./th-shieldwarning.svg": "6LVN",
	"./th-shirtfolded.svg": "aSm6",
	"./th-shootingstar.svg": "hzOH",
	"./th-shoppingbag.svg": "fU/L",
	"./th-shoppingbagopen.svg": "5Y/6",
	"./th-shoppingcart.svg": "deOB",
	"./th-shoppingcartsimple.svg": "RASQ",
	"./th-shower.svg": "B0em",
	"./th-shrimp.svg": "i0OC",
	"./th-shuffle.svg": "PJLn",
	"./th-shuffleangular.svg": "sMxV",
	"./th-shufflesimple.svg": "MfZH",
	"./th-sidebar.svg": "KKc4",
	"./th-sidebarsimple.svg": "fhvF",
	"./th-sigma.svg": "hJRF",
	"./th-signature.svg": "qxJE",
	"./th-signin.svg": "DpHG",
	"./th-signout.svg": "IubV",
	"./th-signpost.svg": "9oBO",
	"./th-simcard.svg": "7jvy",
	"./th-siren.svg": "g6LG",
	"./th-sketchlogo.svg": "Ma0v",
	"./th-skipback.svg": "f33H",
	"./th-skipbackcircle.svg": "lX6D",
	"./th-skipforward.svg": "fJih",
	"./th-skipforwardcircle.svg": "kdq9",
	"./th-skull.svg": "mnnd",
	"./th-slacklogo.svg": "zgBA",
	"./th-sliders.svg": "kqNO",
	"./th-slidershorizontal.svg": "fzXZ",
	"./th-slideshow.svg": "HRqJ",
	"./th-smiley.svg": "qS9X",
	"./th-smileyangry.svg": "loE4",
	"./th-smileyblank.svg": "pE15",
	"./th-smileymeh.svg": "WGt+",
	"./th-smileynervous.svg": "PrY9",
	"./th-smileysad.svg": "kKBK",
	"./th-smileysticker.svg": "8ncE",
	"./th-smileywink.svg": "fc1N",
	"./th-smileyxeyes.svg": "NRhb",
	"./th-snapchatlogo.svg": "xH8+",
	"./th-sneaker.svg": "kh74",
	"./th-sneakermove.svg": "7+NB",
	"./th-snowflake.svg": "9XQ7",
	"./th-soccerball.svg": "6TSe",
	"./th-sortascending.svg": "uJqE",
	"./th-sortdescending.svg": "Um49",
	"./th-soundcloudlogo.svg": "4IZC",
	"./th-spade.svg": "MyIK",
	"./th-sparkle.svg": "hHvR",
	"./th-speakerhifi.svg": "X41X",
	"./th-speakerhigh.svg": "M1uF",
	"./th-speakerlow.svg": "P4AK",
	"./th-speakernone.svg": "JODN",
	"./th-speakersimplehigh.svg": "aM2b",
	"./th-speakersimplelow.svg": "gBQy",
	"./th-speakersimplenone.svg": "sPC4",
	"./th-speakersimpleslash.svg": "d3J9",
	"./th-speakersimplex.svg": "03kG",
	"./th-speakerslash.svg": "lSsl",
	"./th-speakerx.svg": "hitw",
	"./th-spinner.svg": "aDOJ",
	"./th-spinnergap.svg": "OTsP",
	"./th-spiral.svg": "IHs8",
	"./th-splithorizontal.svg": "HAnJ",
	"./th-splitvertical.svg": "/rFf",
	"./th-spotifylogo.svg": "3IeT",
	"./th-square.svg": "1Lq4",
	"./th-squarehalf.svg": "GK9D",
	"./th-squarehalfbottom.svg": "/Cda",
	"./th-squarelogo.svg": "uP7W",
	"./th-squaresfour.svg": "3+Ye",
	"./th-squaresplithorizontal.svg": "gwv8",
	"./th-squaresplitvertical.svg": "snlY",
	"./th-stack.svg": "KKkv",
	"./th-stackoverflowlogo.svg": "VL29",
	"./th-stacksimple.svg": "sTdb",
	"./th-stairs.svg": "pslM",
	"./th-stamp.svg": "5+Lk",
	"./th-star.svg": "dQsP",
	"./th-starandcrescent.svg": "T3Gx",
	"./th-starfour.svg": "l5tH",
	"./th-starhalf.svg": "oQQl",
	"./th-starofdavid.svg": "9+E5",
	"./th-steeringwheel.svg": "iu6q",
	"./th-steps.svg": "gvvm",
	"./th-stethoscope.svg": "483X",
	"./th-sticker.svg": "0oWc",
	"./th-stool.svg": "DSYe",
	"./th-stop.svg": "Cptk",
	"./th-stopcircle.svg": "o8He",
	"./th-storefront.svg": "hnW6",
	"./th-strategy.svg": "eWEm",
	"./th-stripelogo.svg": "HFu+",
	"./th-student.svg": "/kBz",
	"./th-subtitles.svg": "Fubt",
	"./th-subtract.svg": "Y/Zr",
	"./th-subtractsquare.svg": "GEPn",
	"./th-suitcase.svg": "Fixz",
	"./th-suitcaserolling.svg": "Gp7z",
	"./th-suitcasesimple.svg": "7mAw",
	"./th-sun.svg": "X+N6",
	"./th-sundim.svg": "O4V6",
	"./th-sunglasses.svg": "dWtS",
	"./th-sunhorizon.svg": "SSyO",
	"./th-swap.svg": "e8SL",
	"./th-swatches.svg": "T6vo",
	"./th-swimmingpool.svg": "D/Wj",
	"./th-sword.svg": "+Ki+",
	"./th-synagogue.svg": "vlKI",
	"./th-syringe.svg": "Daf3",
	"./th-table.svg": "w28U",
	"./th-tabs.svg": "hdwP",
	"./th-tag.svg": "PiEa",
	"./th-tagchevron.svg": "EOBr",
	"./th-tagsimple.svg": "JkLf",
	"./th-target.svg": "xoqN",
	"./th-taxi.svg": "UWc3",
	"./th-telegramlogo.svg": "v8lT",
	"./th-television.svg": "Q3WB",
	"./th-televisionsimple.svg": "ZPby",
	"./th-tennisball.svg": "Z5tO",
	"./th-tent.svg": "tyXI",
	"./th-terminal.svg": "N0m0",
	"./th-terminalwindow.svg": "qoW5",
	"./th-testtube.svg": "ZSUK",
	"./th-textaa.svg": "G1YI",
	"./th-textaligncenter.svg": "mjKg",
	"./th-textalignjustify.svg": "RNnB",
	"./th-textalignleft.svg": "FkCT",
	"./th-textalignright.svg": "P3XI",
	"./th-textaunderline.svg": "ojS4",
	"./th-textb.svg": "jH1O",
	"./th-textbox.svg": "2O0j",
	"./th-textcolumns.svg": "uQdZ",
	"./th-texth.svg": "XH+1",
	"./th-texthfive.svg": "76oE",
	"./th-texthfour.svg": "aCBc",
	"./th-texthone.svg": "pIpX",
	"./th-texthsix.svg": "rPC0",
	"./th-texththree.svg": "b3MH",
	"./th-texthtwo.svg": "4/Ob",
	"./th-textindent.svg": "pczd",
	"./th-textitalic.svg": "EUG8",
	"./th-textoutdent.svg": "KLxo",
	"./th-textstrikethrough.svg": "nwlp",
	"./th-textt.svg": "Fgfp",
	"./th-textunderline.svg": "u7gH",
	"./th-thermometer.svg": "W4Wi",
	"./th-thermometercold.svg": "q9K3",
	"./th-thermometerhot.svg": "Jo7F",
	"./th-thermometersimple.svg": "xSme",
	"./th-thumbsdown.svg": "1CPE",
	"./th-thumbsup.svg": "FyqY",
	"./th-ticket.svg": "o/sU",
	"./th-tidallogo.svg": "BuLH",
	"./th-tiktoklogo.svg": "ceLw",
	"./th-timer.svg": "8xCh",
	"./th-tipi.svg": "uQXv",
	"./th-toggleleft.svg": "LWmw",
	"./th-toggleright.svg": "n+yo",
	"./th-toilet.svg": "RH/N",
	"./th-toiletpaper.svg": "cg28",
	"./th-toolbox.svg": "6Ndc",
	"./th-tooth.svg": "lGqD",
	"./th-tote.svg": "ss/z",
	"./th-totesimple.svg": "b7ge",
	"./th-trademark.svg": "Y+3+",
	"./th-trademarkregistered.svg": "wyUj",
	"./th-trafficcone.svg": "y0hm",
	"./th-trafficsign.svg": "29K9",
	"./th-trafficsignal.svg": "7Pth",
	"./th-train.svg": "fAwH",
	"./th-trainregional.svg": "QQux",
	"./th-trainsimple.svg": "17Bu",
	"./th-tram.svg": "GlgE",
	"./th-translate.svg": "KA3U",
	"./th-trash.svg": "Xc95",
	"./th-trashsimple.svg": "9Uk8",
	"./th-tray.svg": "NG6I",
	"./th-tree.svg": "m8NM",
	"./th-treeevergreen.svg": "U3QP",
	"./th-treepalm.svg": "T7Gp",
	"./th-treestructure.svg": "/l7I",
	"./th-trenddown.svg": "BlwX",
	"./th-trendup.svg": "YMPb",
	"./th-triangle.svg": "+9ui",
	"./th-trophy.svg": "di0a",
	"./th-truck.svg": "K5Oq",
	"./th-tshirt.svg": "vlo7",
	"./th-twitchlogo.svg": "wkJB",
	"./th-twitterlogo.svg": "/yyD",
	"./th-umbrella.svg": "hq6q",
	"./th-umbrellasimple.svg": "T4gd",
	"./th-unite.svg": "RylB",
	"./th-unitesquare.svg": "KOjp",
	"./th-upload.svg": "jYOm",
	"./th-uploadsimple.svg": "RHTy",
	"./th-usb.svg": "wCom",
	"./th-user.svg": "NMiP",
	"./th-usercircle.svg": "FZLi",
	"./th-usercirclegear.svg": "yHI6",
	"./th-usercircleminus.svg": "JTLg",
	"./th-usercircleplus.svg": "d5OV",
	"./th-userfocus.svg": "FR+n",
	"./th-usergear.svg": "9eIB",
	"./th-userlist.svg": "ENT9",
	"./th-userminus.svg": "WbKw",
	"./th-userplus.svg": "WAPq",
	"./th-userrectangle.svg": "lK+Y",
	"./th-users.svg": "AiKL",
	"./th-usersfour.svg": "1ld7",
	"./th-usersquare.svg": "nUDH",
	"./th-usersthree.svg": "9Jnn",
	"./th-userswitch.svg": "2fbM",
	"./th-van.svg": "/s30",
	"./th-vault.svg": "TfBY",
	"./th-vibrate.svg": "1+W7",
	"./th-video.svg": "UPUE",
	"./th-videocamera.svg": "VsG4",
	"./th-videocameraslash.svg": "veDZ",
	"./th-vignette.svg": "gNZd",
	"./th-vinylrecord.svg": "jfCr",
	"./th-virtualreality.svg": "u4zc",
	"./th-virus.svg": "mnyt",
	"./th-voicemail.svg": "/pxb",
	"./th-volleyball.svg": "Dbuu",
	"./th-wall.svg": "X0HN",
	"./th-wallet.svg": "thlp",
	"./th-warehouse.svg": "9fQq",
	"./th-warning.svg": "h0tM",
	"./th-warningcircle.svg": "t2DR",
	"./th-warningdiamond.svg": "W0jw",
	"./th-warningoctagon.svg": "Y7Tm",
	"./th-watch.svg": "A1oa",
	"./th-waveform.svg": "eGVj",
	"./th-waves.svg": "G9VE",
	"./th-wavesawtooth.svg": "FUB1",
	"./th-wavesine.svg": "w7UG",
	"./th-wavesquare.svg": "Q59Z",
	"./th-wavetriangle.svg": "t6P3",
	"./th-webcam.svg": "j1FB",
	"./th-webcamslash.svg": "5rv6",
	"./th-webhookslogo.svg": "L8Jn",
	"./th-wechatlogo.svg": "3he0",
	"./th-whatsapplogo.svg": "7p4p",
	"./th-wheelchair.svg": "f74y",
	"./th-wheelchairmotion.svg": "tjxv",
	"./th-wifihigh.svg": "eRDf",
	"./th-wifilow.svg": "a2ks",
	"./th-wifimedium.svg": "mNC4",
	"./th-wifinone.svg": "lbZA",
	"./th-wifislash.svg": "gp+I",
	"./th-wifix.svg": "SHAX",
	"./th-wind.svg": "CMad",
	"./th-windowslogo.svg": "90QG",
	"./th-wine.svg": "TWXE",
	"./th-wrench.svg": "eNA+",
	"./th-x.svg": "jZRd",
	"./th-xcircle.svg": "qcpB",
	"./th-xsquare.svg": "xoEH",
	"./th-yinyang.svg": "PhTp",
	"./th-youtubelogo.svg": "8+OY",
	"./theme.svg": "hdtf",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./window-max.svg": "HR+Z",
	"./window-restore.svg": "ardY",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 84